<template>

  <modalo
    :title="job.title"
    type="medium"
    @hideModal="hideModal()"
    :modaloWatch="() => jobEdit">

    <creating
      v-if="creating"
      height="100%" />
    <div v-if="!creating">
      <UnavailableJob
        v-if="!availableNewJob" />

      <div v-if="availableNewJob">
        <ul
          class="nav nav-tabs mb-3"
          :class="{'box-loading': loading}">
          <li class="nav-item">
            <a class="nav-link" 
              :class="{active: tab === 'details'}" 
              @click="saveJob(jobEdit, function () { changeTab('details') })" 
              href="javascript:void(0)">
              {{ $t('Details') }}
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link" 
              :class="{active: tab === 'stages', disabled: !jobId}" 
              @click="saveJob(jobEdit, function () { changeTab('stages') })" 
              href="javascript:void(0)">
              {{ $t('Stages') }}
              </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link" 
              :class="{active: tab === 'questions', disabled: !jobId}" 
              @click="saveJob(jobEdit, function () { changeTab('questions') })" 
              href="javascript:void(0)">
              {{ $t('Questions') }}
              </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link" 
              :class="{active: tab === 'publish', disabled: !jobId}" 
              @click="saveJob(jobEdit, function () { changeTab('publish') })" 
              href="javascript:void(0)">
              {{ $t('Publication') }}
              </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link" 
              :class="{active: tab === 'control', disabled: !jobId}" 
              @click="saveJob(jobEdit, function () { changeTab('control') })" 
              href="javascript:void(0)">
              {{ $t('Control') }}
              </a>
          </li>
        </ul>

        <div>
          <div v-if="tab === 'details'">
            <job-form-details 
              :initJob="job"
              :validateErrors="validateErrors" 
              @changed="changed">
              </job-form-details>
          </div>
          <div v-if="tab === 'stages'">
            <!--<job-form-stages 
              :initJob="job" 
              :validateErrors="validateErrors"
              @changed="changed">
              </job-form-stages>
            <hr>-->
            <job-form-stages2
              :initJob="job" 
              :validateErrors="validateErrors"
              @changed="changed">
              </job-form-stages2>
          </div>
          <div v-if="tab === 'publish'">
            <job-form-publish 
              :initJob="job" 
              :validateErrors="validateErrors"
              @changed="changed">
              </job-form-publish>
          </div>
          <div v-if="tab === 'questions'">
            <job-form-questions 
              :initJob="job" 
              :validateErrors="validateErrors"
              @changed="changed">
              </job-form-questions>
          </div>
          <div v-if="tab === 'control'">
            <job-form-control 
              :initJob="job" 
              :validateErrors="validateErrors"
              @changed="changed">
              </job-form-control>
          </div>
        </div>
      </div>
    </div>
    <template
      v-if="availableNewJob && !creating"
      slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          v-if="isNew && tab !== 'control'"
          type="button"
          class="btn btn-primary"
          @click="saveJob(jobEdit, nextTab)">{{ $t('Next') }}</button>
        <button
          v-if="!isNew || tab === 'control'"
          type="button"
          class="btn btn-primary"
          @click="saveJob(jobEdit, emitSaved)">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click.stop="hideModal()">{{ $t('Cancel') }}</button>
        <!--<button
          type="button"
          class="btn btn-danger"
          @click="deleteJob(jobId)">{{ $t('Delete') }}</button>-->
      </div>
    </template>

  </modalo>

</template>

<script>
import JobFormDetails from './JobFormDetails'
import JobFormStages from './JobFormStages'
import JobFormStages2 from './JobFormStages2'
import JobFormPublish from './JobFormPublish'
import JobFormQuestions from './JobFormQuestions'
import JobFormControl from './JobFormControl'
import Modal from '@/components/Modal/Modal'
import UnavailableJob from '@/components/Unavailable/UnavailableJob'

export default {
  name: 'JobForm',
  components: {
    JobFormDetails,
    JobFormStages,
    JobFormStages2,
    JobFormPublish,
    JobFormQuestions,
    JobFormControl,
    Modal,
    UnavailableJob
  },
  props: {
    initJob: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    const jobId = this.initJob._id
    return {
      jobId,
      creating: true,
      loading: false,
      job: this.defaultValues(this.initJob),
      jobEdit: this.defaultValues(this.initJob),
      tab: 'details',
      isNew: !jobId,
      wasChanged: !jobId,
      validateErrors: {}
    }
  },
  computed: {
    resourceAvailability () {
      return this.$store.getters.getAccountResourceAvailability
    },
    availableNewJob () {
      return (this.isNew && this.resourceAvailability.openNewJob === true) || !this.isNew
    }
  },
  created () {
    this.$store.dispatch('setAccountResourceAvailability', {}).then(() => {
      this.creating = false
    })
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      const accountSettings = this.$store.getters.getAccount.settings || {}

      return values._id
      ? this.$clone(values)
      : Object.assign({
        'status': 'open',
        'publicate': 'published',
        'openings': 1,
        'remuneration_period': 'month',
        'team_users': [
          this.$store.getters.getMe
        ],
        // 'stages': [],
        'title': null,
        'description': null,
        'requirements': null,
        'benefits': null,
        'comments': null,
        'currency': accountSettings.currency_default,
        'remuneration': null,
        'remuneration_max': null,
        'country': null,
        'region': null,
        'city': null,
        'neighborhood': null,
        'address': null,
        'zipcode': null,
        'workplace_type': null,
        'hiring_manager_name': null,
        'hiring_manager_email': null,
        'company_id': null,
        'departament_id': null,
        'contract_id': null,
        'owner_user_id': this.$store.getters.getMe,
        'category': null,
        'experience_level': null,
        'education_degree': null,
        'custom_fields': {}
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    changed
    */
    changed (data) {
      this.wasChanged = true
      this.jobEdit = {
        ...this.jobEdit,
        ...data
      }
    },
    /*
    saveJob
    */
    saveJob (data, action) {
      if (this.wasChanged === false) {
        action()
      } else {
        if (this.jobId) {
          this.updateJob(data, action)
        } else {
          this.createJob(data, action)
        }
      }
    },
    /*
    createJob
    */
    createJob (data, action) {
      this.loading = true

      this.$store
      .dispatch('createJob', data)
      .then((response) => {
        this.loading = false
        this.$store.dispatch('refreshSelectJobs')
        this.$store.dispatch('resetLastModalo')
        this.jobId = response._id
        this.job = response
        this.wasChanged = false
        action()
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateJob
    */
    updateJob (data, action) {
      this.loading = true

      this.$store
      .dispatch('updateJob', {
        _id: this.jobId,
        ...data
      })
      .then((response) => {
        this.loading = false
        this.$store.dispatch('refreshSelectJobs')
        this.$store.dispatch('resetLastModalo')
        this.job = response
        this.wasChanged = false
        action()
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    deleteJob
    */
    deleteJob (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store.dispatch('deleteJob', id)
        .then((result) => {
          this.loading = false
          this.$emit('deleted')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    },
    /*
    tab
    */
    changeTab (tab) {
      this.tab = tab
    },
    nextTab () {
      const tabs = ['details', 'stages', 'questions', 'publish', 'control']
      const nextTab = tabs[ tabs.indexOf(this.tab) + 1 ]
      this.changeTab(nextTab)
    },
    /*
    emitSaved
    */
    emitSaved () {
      this.$emit('saved', this.job)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/JobForm/JobForm.vue